import { Alert } from "@productlane/ui"

import { useTrial } from "@/lib/useTrial"
import { SettingsContainer } from "@/screens/settings/settings-switches/settings-container"
import { SettingsHeader } from "../../settings-header"
import { ImportPortalBadge } from "../import-portal"
import { CsvUploadField } from "./steps/csv-upload-field"

export function CsvImportPage() {
	const { hasTrialEnded } = useTrial()

	return (
		<>
			<SettingsHeader
				title="CSV import"
				subtitle={null}
				titleSuffix={<ImportPortalBadge />}
			/>
			{!hasTrialEnded ? (
				<SettingsContainer>
					<CsvUploadField />
				</SettingsContainer>
			) : (
				<Alert variant="warning">Trial ended. Upgrade to import data.</Alert>
			)}
		</>
	)
}
